import { render, staticRenderFns } from "./ConfigurationModal.vue?vue&type=template&id=50b47fe9&scoped=true&"
import script from "./ConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./ConfigurationModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationModal.vue?vue&type=style&index=0&id=50b47fe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b47fe9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b47fe9')) {
      api.createRecord('50b47fe9', component.options)
    } else {
      api.reload('50b47fe9', component.options)
    }
    module.hot.accept("./ConfigurationModal.vue?vue&type=template&id=50b47fe9&scoped=true&", function () {
      api.rerender('50b47fe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/samurai/Settings/components/ConfigurationModal.vue"
export default component.exports